import PropTypes from 'prop-types';

export const children = PropTypes.node;
export const handler = PropTypes.func;
export const childrenOrValue = PropTypes.oneOfType([children, PropTypes.number, PropTypes.string]);
export const date = PropTypes.string;
export const timezone = PropTypes.string;
export const format = PropTypes.string;
export const flag = PropTypes.bool;
export const photo = PropTypes.shape({
  url: PropTypes.string.isRequired,
  thumbnail: PropTypes.string.isRequired,
});

export const permissions = PropTypes.shape({
  appointments: PropTypes.shape({
    view: PropTypes.bool,
    modify: PropTypes.bool,
    history: PropTypes.bool,
    book: PropTypes.bool,
  }),
  clients: PropTypes.shape({
    view: PropTypes.bool,
    modify: PropTypes.bool,
    add: PropTypes.bool,
  }),
  services: PropTypes.shape({
    view: PropTypes.bool,
    modify: PropTypes.bool,
    add: PropTypes.bool,
  }),
  workHours: PropTypes.shape({
    view: PropTypes.bool,
    modify: PropTypes.bool,
    add: PropTypes.bool,
  }),
  bankAccount: PropTypes.shape({
    view: PropTypes.bool,
    modify: PropTypes.bool,
    add: PropTypes.bool,
  }),
  profile: PropTypes.shape({
    view: PropTypes.bool,
    modify: PropTypes.bool,
  }),
  reports: PropTypes.shape({
    view: PropTypes.bool,
  }),
  barberSettings: PropTypes.shape({
    view: PropTypes.bool,
    modify: PropTypes.bool,
  }),
  settings: PropTypes.shape({
    view: PropTypes.bool,
    modify: PropTypes.bool,
  }),
  barbers: PropTypes.shape({
    view: PropTypes.bool,
    modify: PropTypes.bool,
  }),
  timeTrack: PropTypes.shape({
    view: PropTypes.bool,
  }),
  products: PropTypes.shape({
    view: PropTypes.bool,
    modify: PropTypes.bool,
  }),
  dashboard: PropTypes.shape({
    view: PropTypes.bool,
  }),
  analytics: PropTypes.shape({
    view: PropTypes.bool,
  }),
  register: PropTypes.shape({
    view: PropTypes.bool,
  }),
  cashRegister: PropTypes.shape({
    view: PropTypes.bool,
  }),
  dailySummary: PropTypes.shape({
    view: PropTypes.bool,
  }),
  dailySummaryHistory: PropTypes.shape({
    view: PropTypes.bool,
  }),
  taxes: PropTypes.shape({
    view: PropTypes.bool,
    modify: PropTypes.bool,
  }),
  discounts: PropTypes.shape({
    view: PropTypes.bool,
    modify: PropTypes.bool,
  }),
  promos: PropTypes.shape({
    view: PropTypes.bool,
    modify: PropTypes.bool,
  }),
  waitingList: PropTypes.shape({
    view: PropTypes.bool,
    modify: PropTypes.bool,
  }),
});
